<template lang="pug">
#discounts.center-panel.md-scrollbar.md-theme-default
  md-content.md-elevation-1(md-theme="white")
    sort-table(
      v-bind:columns="tableColumns" v-model="discounts" @refresh="getDiscounts" v-bind:per-page="perPage" 
      v-bind:total="discountsAmount" link table-id="discounts" ref="table" v-on:create="addDiscount" tableHeight="calc(100% - 48px)"
    )
      template(slot="actions" slot-scope="scope")
        span
          md-button.md-icon-button.md-dense.small(@click.stop="discountIdToDelete = scope.item.id; deleteDialog = true;"): md-icon delete
          md-tooltip(md-direction="top") Удалить скидку
    //md-button.md-dense(v-bind:to="{ name: 'Discount', params: {discountid: 'new'} }") Добавить скидку #[md-icon add]
    md-dialog-confirm(:md-active.sync="deleteDialog" md-title="Удалить скидку?" md-content="Внимание! Действие необратимо!" md-confirm-text="Удалить" md-cancel-text="Отмена" @md-cancel="deleteDialog = false; discountIdToDelete = null;" @md-confirm="deleteDiscount")
</template>

<script>
import SortTable from '@/components/SortTable'
import CostMenu from './menu.vue';
export default {
  components: { SortTable, CostMenu },
  data() {
    return {
      perPage: 25,
      tableColumns: [
        { label: 'ID', field: 'id', default: true, sortable: true },
        { label: 'Название', field: 'name', sortable: true },
        { label: '', field: 'actions' },
      ],
      deleteDialog: false,
      discountIdToDelete: null
    }
  },
  metaInfo() {
    return {
      title: 'Скидки'
    }
  },
  computed: {
    discounts() {
      return this.$store.state.cost.discounts.map(discount => {
        discount.routerLink = { name: 'Discount', params: {discountid: discount.id}, query: this.$route.query};
        return discount;
      });
    },
    discountsAmount() {
      return this.$store.state.cost.discounts_amount
    }
  },
  created() {
    this.$store.commit('setTitle', 'Скидки')
  },
  methods: {
    addDiscount() {
      this.$router.push({ name: 'Discount', params: {discountid: 'new'} });
    },
    //получение зон
    getDiscounts(page, count, orderBy, orderType) {
      this.$store.dispatch('cost/getDiscounts', {
        count: count,
        page:  page,
        order_by:   orderBy,
        order_type: orderType
      });
    },
    deleteDiscount() {
      this.$store.dispatch('cost/deleteDiscount', { id: this.discountIdToDelete }).then(() => {
        this.$nextTick(() => {
          this.$refs.table.reload()
        })
      })
      this.$store.state.cost.discounts.forEach((discount, index) => {
        if (discount.id == this.discountIdToDelete) this.$store.state.cost.discounts.splice(index, 1)
      })
    }
  },
}
</script>


// WEBPACK FOOTER //
// Discounts.vue?786aae09